import {useSyncExternalStore} from 'react'

const useResize = (handleCallback: () => void) => {
    useSyncExternalStore(
        () => {
            window.addEventListener('resize', handleCallback)

            return () => {
                window.removeEventListener('resize', handleCallback)
            }
        },
        () => {},
        () => {},
    )
}

export default useResize
